module.exports = __webpack_public_path__ + "static/media/linkedin-dark-blue.11eaee34.svg";